/**
 * Transaction amount direction for reporting — aligned with TransactionList in/out flow logic.
 * App stores `type` as debit | credit | transfer with positive debit amounts.
 */

export interface ReportTransactionAmountLike {
  type: string | null;
  amount: number;
}

/** Money leaving an account (spend / expense). Transfers excluded without account context. */
export function isExpenseOutflow(tx: ReportTransactionAmountLike): boolean {
  const type = (tx.type ?? '').toLowerCase();
  if (type === 'credit' || type === 'income') return false;
  if (type === 'transfer') return false;
  if (type === 'debit' || type === 'expense') return true;
  return tx.amount < 0;
}

/** Money entering an account (income). Transfers excluded without account context. */
export function isIncomeInflow(tx: ReportTransactionAmountLike): boolean {
  const type = (tx.type ?? '').toLowerCase();
  if (type === 'debit' || type === 'expense') return false;
  if (type === 'transfer') return false;
  if (type === 'credit' || type === 'income') return true;
  return tx.amount > 0;
}

export function expenseOutflowAmount(tx: ReportTransactionAmountLike): number {
  return isExpenseOutflow(tx) ? Math.abs(Number(tx.amount) || 0) : 0;
}

export function incomeInflowAmount(tx: ReportTransactionAmountLike): number {
  return isIncomeInflow(tx) ? Math.abs(Number(tx.amount) || 0) : 0;
}
